import { Icon } from '@iconify/react';
import pizzaIcon from '@iconify/icons-mdi/pizza';

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const pizzasConfig = () => ({
  title: 'Pizzas',
  path: '/products/pizzas',
  icon: getIcon(pizzaIcon),
  children: [
    { title: 'Relatórios', path: '/products/pizzas/reports' },
    { title: 'Categorias', path: '/products/pizzas/categories' },
    { title: 'Sabores', path: '/products/pizzas/flavors' },
    { title: 'Ingredientes', path: '/products/pizzas/ingredients' },
    { title: 'Bordas', path: '/products/pizzas/borders' },
    { title: 'Preços dos Sabores', path: '/products/pizzas/flavor-prices' },
    { title: 'Preços das Categorias', path: '/products/pizzas/categories-prices' },
    { title: 'Preços dos Ingredientes', path: '/products/pizzas/ingredients-prices' },
    { title: 'Preços das Bordas', path: '/products/pizzas/borders-prices' },
    { title: 'Totens', path: '/products/pizzas/totens' },
    { title: 'Config Totem Pizza', path: '/products/pizzas/config-totem' },
    { title: 'Imagens do Totem', path: '/products/pizzas/totem-images' },
  ],
});

export default pizzasConfig;
